export enum P4ValidationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  SLA_EXPIRED = "SLA_EXPIRED",
}

export enum RiskClassification {
  LOW = "LOW",
  STANDARD = "STANDARD",
  HIGH = "HIGH",
}

// Aligné sur l'enum backend ScoringTrigger (source de vérité) : une valeur inconnue côté FE
// rendrait un badge vide et un filtre inopérant. Voir chk_p4_source (migration V1078).
export enum ScoringTrigger {
  ONBOARDING = "ONBOARDING",
  ICR_CHANGE = "ICR_CHANGE",
  SCREENING_HIT = "SCREENING_HIT",
  BATCH = "BATCH",
  MANUAL = "MANUAL",
  ERROR = "ERROR",
}

export interface P4ValidationItem {
  validationId: string;
  businessKey: string;
  oldRiskClass: RiskClassification;
  newRiskClass: RiskClassification;
  oldScore: number;
  newScore: number;
  scoreDelta: number;
  triggerReason: string;
  sourceTrigger: ScoringTrigger;
  status: P4ValidationStatus;
  slaDeadline: string;
  slaExpired: boolean;
  flaggedForDirectionRisques: boolean;
  createdAt: string;
}

export interface P4PendingCount {
  count: number;
}
